import React, { Fragment } from 'react'
import ProfileDetail from '../../Components/MyProfile'

const MyProfile = () => {
    return (
        <Fragment>
            <ProfileDetail />
        </Fragment>
    )
}

export default MyProfile